<template>
    <section>
        <div v-if="loader.body" class="loading">
            <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
        </div>

        <div v-else>
            <ui-table
                v-if="!msgUploadContracts.noContracts"
                :columns="columns"
                :data="contracts"
                :loading="false"
                :table-header-fixed="false"
                :is-fixed-list="true"
                :last-col-fixed="true"
                :select-column-menu="true"
                :selectable="contractsFeaturesIsAllowed"
                name="ContractsTable"
                check-padding-left="20px"
                max-height="342px"
                not-found-text="Não foi possível encontrar nenhum contrato."
                not-found-icon="fa fa-file-contract"
                tr-component="contracts/contracts-in-pdf/table-line"
                custom-load-area
                disable-ref
                @select-all="selectedAll"
                @selected="selectedHandler"
            />

            <div
                v-if="msgUploadContracts.noContracts && !contractsFeaturesIsAllowed"
                class="loading"
            >
                <small>Não há dados para exibir.</small>
            </div>

            <div
                v-if="contractsFeaturesIsAllowed"
                class="bottom-send-contract"
                :class="{ 'bottom-send-contract-no': msgUploadContracts.noContracts }"
            >
                <div
                    class="send-contract"
                    :class="{ 'send-contract-no': msgUploadContracts.noContracts }"
                >
                    <div class="itens">
                        <div v-if="msgUploadContracts.noContracts" class="no-item">
                            <em class="fal fa-file-contract"/>
                        </div>
                        <span
                            class="title"
                            @click="handleLineClick"
                            v-html="msgUploadContracts.msg"
                        />
                        <div class="button">
                            <input
                                id="file-button"
                                ref="files"
                                type="file"
                                name="files"
                                style="display: none"
                                accept="application/pdf"
                                @change="handleFiles"
                            />
                            <label
                                id="send-contract-label"
                                class="upload-pdf"
                                for="file-button"
                                @click="sendFileHandler">
                                <em class="fal fa-upload"/> Enviar contrato
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiTable, uiLoadIndicator } from '@/components/ui'

	import { files, deal } from '@/services/axios'

	const defaultLoader = () => ({
		body: false,
	})

	export default {
		name: 'contracts-in-pdf',

		components: {
			uiTable,
			uiLoadIndicator
		},

		props: {
			dealId: {
				type: Number,
				default: undefined,
			},

			selectedContractsSync: {
				type: Array,
				default() {
					return []
				}
			},
			/**
			 * Configurações necessárias para saber se o Gerador de Documentos e
			 * Contratos está ativo
			 */
			enabledFeatures: {
				type: Object,
				required: true,
				default() {
					return {
						contracts: true,
					}
				}
			}
		},

		data() {
			return {
				contracts: [],
				selectedContracts: [],

				openContent: false,
				columns: [
					{ title: 'Nome' },
					{ title: 'Tipo' },
					{ title: 'Última atualização' },
					{ title: '' },
				],

				loader: { ...defaultLoader() },
				contractsFeaturesIsAllowed: false,
			}
		},

		computed: {
			/**
			 * Retorna um objeto com uma mensagem a ser mostrada no template e uma flag indicando se
			 * existem contratos cadastrados
			 */
			msgUploadContracts() {
				let msg = 'Enviar um contrato em PDF clicando no botão abaixo'
				let noContracts = false
				if (this.contracts.length == 0) {
					msg = 'Nenhum contrato foi gerado. '
					if (this.enabledFeatures.contracts) {
						msg += 'Utilize um <a id="model" href="#" style="text-decoration: underline">modelo</a> para gerar ou faça o upload do PDF clicando no botão abaixo.'

					} else {
						msg += "Suba seus arquivos pdf's abaixo."
					}
					noContracts = true
				}

				return { msg, noContracts }
			},

			getSelectedContracts() {
				return this.selectedContracts
			},
		},

		watch: {
			getSelectedContracts: {
				handler(newVal) {
					this.$emit('update:selectedContractsSync', newVal)
				},

				deep: true,
			},
		},

		async mounted() {
			this.$root.$on('contracts-features-is-allowed', (bool) => {
				// Verify if user_group is allowed to use contracts features
				this.contractsFeaturesIsAllowed = bool
			})

			setTimeout(async () => {
				await this.getContractsList()
			}, 500)

			this.$root.$on('refresh-contracts-list', async () => {
				await this.getContractsList()
			})
		},

		beforeDestroy() {
			this.$root.$off('contracts-features-is-allowed')
			this.$root.$off('refresh-contracts-list')
		},

		methods: {
			handleLineClick(e) {
				let clickedElId = e.target.id
				if (clickedElId === 'model') {
					return this.$emit('input', null, 'Modelos')
				}
			},

			open() {
				this.openContent = !this.openContent
			},

			selectedAll(bool) {
				this.$root.$emit('select-all-contract-in-pdf', bool)
			},

			async getContractsList() {
				this.loader.body = true

				try {
					const { data } = await deal.getV2('', this.dealId)

					// Create deal_id param
					data.data.files.forEach((item) => {
						item.deal_id = this.dealId
					})

					this.contracts = data.data.files
				} catch (error) {
					console.log(error)
					this.contracts = null
				}

				this.loader.body = false
			},

			async linkFileToDeal(dealId, fileId) {
				try {
					const { data } = await deal.linkFileToDeal(dealId, fileId)

					// Show request infos
					if (data.status === 'success') this.$toastr.s(data.msg)
					else this.$toastr.w(data.msg)
				} catch (error) {
					console.log(error)
				}
			},

			async uploadFileToCDN(data) {
				try {
					const response = await files.create('', data)
					const fileId = response.data[0].file.id

					await this.linkFileToDeal(this.dealId, fileId)
				} catch (error) {
					console.log(error)
				}
			},

			async handleFiles() {
				let dataForm = new FormData()
				let invalid = false

				for (let file of this.$refs.files.files) {
					if (file.type !== 'application/pdf') {
						this.$toastr.e('O arquivo não é do formato PDF.')
						invalid = true
					}

					dataForm.append(`file`, file)
				}

				// Update PDF only
				if (invalid) return

				// Show loading warning
				this.$root.$emit('contracts-loading-warning', true)

				await this.uploadFileToCDN(dataForm)
				await this.getContractsList()

				// Disable loading warning
				this.$root.$emit('contracts-loading-warning', false)
			},

			selectedHandler(event) {
				let contracts = [...this.selectedContracts].filter((item) => item != event.id)

				// Add if selected
				if (event.checked) {
					contracts.push(event.id)
				}

				this.selectedContracts = contracts
			},
			/**
			 * Event handler que trata o evento de quando o envio de um contrato é
			 * requisitado
			 */
			sendFileHandler() {
				// Emite o evento do Google Analytics
				this.$gtm.trackEvent({
					event: 'fac_button_click',
					category: 'vue-enviar-contrato',
					action: 'click',
					label: 'Enviar Contrato'
				})
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
